export const data = [
    {
        title: 'Услуга «Смотри везде»',
        desc: 'Просмотр каналов на нескольких экранах одновременно.',
        action: '/domru-tv/watch-everywhere',
        textButton: 'Узнать, как смотреть везде',
        background: 'linear-gradient(103.98deg, #21CC69 0%, #21CCC2 100%)'
    },
    {
        title: 'Услуга «Управляй просмотром»',
        desc: 'Перематывайте рекламу и ставьте прямой эфир на паузу.',
        action: '/catchup',
        textButton: 'Как управлять просмотром',
        background: 'linear-gradient(288.42deg, #FFB800 0%, #F4D900 100%)'
    },
    {
        title: 'Услуга «Кинотеатр Movix»',
        desc: 'Кино и сериалы вне эфира, смотри, что нравится в удобное время. ',
        action: 'https://movix.ru/',
        textButton: 'Выбрать каналы',
        background: 'linear-gradient(288.42deg, #9179F0 0%, #D079F0 100%)'
    },
];
